import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PrCategoryService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/pr-categories', params);
    }

    store(body: any) {
        return super.post(`/pr-categories`, body);
    }

    edit(prProductId: number, params: any = {}) {
        return super.get(`/pr-categories/${prProductId}/edit`, params);
    }

    update(prProductId: number, body: any) {
        return super.put(`/pr-categories/${prProductId}`, body);
    }

    destroy(prProductId: number) {
        return super.delete(`/pr-categories/${prProductId}`);
    }

    select(params: any = {}) {
        return super.get(`/pr-categories/select`, params);
    }
}
